<template>
  <div class="components-container">
    <header>
      <span class="title">邀请码</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-button size="small" @click="dialogDelete = true" :disabled="disabled" v-if="funAuth.includes(23)">删  除</el-button>
        <el-button type="primary" @click="AddDialog" v-if="funAuth.includes(21)">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @row-click="rowClick" @selection-change='handleSelectionChange'>
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='invite_code' label='邀请码' min-width='120'></el-table-column>
      <el-table-column prop='quantity' label='允许使用次数' min-width='120'></el-table-column>
      <el-table-column prop='use_number' label='已使用次数' min-width='120'></el-table-column>
      <el-table-column label='有效期截止日期' min-width='140'>
        <template slot-scope='scope'>{{ scope.row.end_time | formatDate('yyyy-MM-dd') }}</template>
      </el-table-column>
      <el-table-column label='状态' min-width='100'>
        <template slot-scope='scope'>
          <span v-text="statusData[scope.row.status]"></span>
        </template>
      </el-table-column>
      <el-table-column prop='create_by' label='创建人' min-width='120'></el-table-column>
      <el-table-column label='创建时间' min-width='160'>
        <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <div class="mask n1" v-if="dialogDetail" @click="dialogDetail = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip" v-if="dialogDetail">
        <header>
          <img src="/static/images/icon-company.png">
          {{inviteCodeDtl.invite_code}}
          <i class="iconfont icon-close" @click="dialogDetail = false"></i>
        </header>
        <div class="tab-box">
          <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>基本资料</span></div>
          <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)" v-if="moduleIds.includes(1) || moduleIds.includes(2)"><span>客户</span></div>
          <div class="tab-item" :class="(tabType == 2)?'active':''" @click="dtlChange(2)"><span>操作记录</span></div>
        </div>
        <div class="head" v-if="tabType == 0">
          <span>基本资料</span>
          <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(23)">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">删  除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="editDialog" v-if="funAuth.includes(22)">编 辑</el-button>
        </div>
        <div class="head" v-if="tabType == 1">
          <span>客户</span>
        </div>
        <div class="head" v-if="tabType == 2">
          <span>操作记录</span>
        </div>
        <div class="content">
          <el-collapse v-model="activeNames" v-if="tabType == 0">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                基本信息
              </template>
              <div class="form">
                <div class="item single">
                  <span class="title">邀请码</span>
                  <div class="item-content">{{inviteCodeDtl.invite_code}}</div>
                </div>
                <div class="item">
                  <span class="title">允许使用次数</span>
                  <div class="item-content">{{inviteCodeDtl.quantity}}</div>
                </div>
                <div class="item">
                  <span class="title">已经使用次数</span>
                  <div class="item-content">{{inviteCodeDtl.use_number}}</div>
                </div>
                <div class="item">
                  <span class="title">状态</span>
                  <div class="item-content" v-text="statusData[inviteCodeDtl.status]"></div>
                </div>
                <div class="item">
                  <span class="title">有效截止日期</span>
                  <div class="item-content">{{inviteCodeDtl.end_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item single">
                  <span class="title">备注</span>
                  <div class="item-content">{{inviteCodeDtl.remark}}</div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                系统信息
              </template>
              <div class="form">
                <div class="item">
                  <span class="title">创建人</span>
                  <div class="item-content">{{inviteCodeDtl.create_by}}</div>
                </div>
                <div class="item">
                  <span class="title">创建时间</span>
                  <div class="item-content">{{inviteCodeDtl.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>

          <el-table class="el-table-02" :data='userList' style='width: 100%' @row-click="userRow" key='Table2' v-if="tabType == 1">
            <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
            <el-table-column prop='user_name' label='客户姓名' min-width='140'></el-table-column>
            <el-table-column prop='phone' label='联系电话' min-width='140'></el-table-column>
            <el-table-column label='客户类型' min-width='160'>
              <template slot-scope='scope'>{{ customerData.belong_type == 1 ? '试用客户' : '正式客户' }}</template>
            </el-table-column>
          </el-table>
          <el-pagination @size-change='handleSizeChange2' @current-change='handleCurrentChange2' :current-page='pageNum2' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize2' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal2' v-if="tabType == 1"></el-pagination>
          <div class="log-box" v-if="tabType == 2">
            <div class="log-item" v-for="(date, index) in logList" :key="index">
              <div class="line">
                <div class="circle"></div>
              </div>
              <div class="rihgt">
                <div class="time">{{date.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                <div class="content">{{date.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-container>
    </transition>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <el-container class="add-dialog" v-if="dialogAdd">
        <header>
          <span>邀请码</span>
          <i class="iconfont icon-close" @click="dialogAdd = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <div class="h1">邀请码</div>
            <div class="h2">注册时特殊的通行证</div>
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item single" v-if="!dialogDetail">
                <span class="item-title"><span class="need">*</span>生成个数</span>
                <div class="item-right">
                  <el-input v-model="number" placeholder="请输入(必填)" size="medium" type="number"></el-input>
                </div>
                <div class="err" v-if="err_n"><i class="el-icon-warning"></i>{{err_n}}</div>
              </div>
              <div class="form-item">
                <span class="item-title item-title2"><span><span class="need">*</span>允许</span><span>使用次数</span></span>
                <div class="item-right">
                  <el-input v-model="quantity" placeholder="请输入(必填)" size="medium" type="number"></el-input>
                </div>
                <div class="err" v-if="err_q"><i class="el-icon-warning"></i>{{err_q}}</div>
              </div>
              <div class="form-item">
                <span class="item-title item-title2"><span><span class="need">*</span>有效</span><span>截止时间</span></span>
                <div class="item-right">
                  <el-date-picker v-model="endTime" type="date" placeholder="选择日期" value-format="timestamp"></el-date-picker>
                </div>
                <div class="err" v-if="err_et"><i class="el-icon-warning"></i>{{err_et}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title">备注</span>
                <div class="item-right">
                  <el-input type="textarea" v-model="remark" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogAdd = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>
    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后该邀请码将不可用，已使用的客户不受影响。</div>
      <div class="prompt">你确定要删除该邀请码吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>

    <div class="mask n1" v-if="dialogCusDetail" @click="dialogCusDetail = false"></div>
    <transition name="slide">
      <trial-detail v-if="dialogCusDetail && customerData.belong_type == 1" :customer="customerData"></trial-detail>
      <customer-detail v-if="dialogCusDetail && customerData.belong_type != 1" :customer="customerData"></customer-detail>
    </transition>
  </div>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import inviteCodeJS from '@/controller/inviteCode.js'
import customerDetail from '@/common/components/customer-detail'// 详情
import trialDetail from '@/common/components/trial-detail'// 试用客户详情
export default {
  data () {
    return {
      defaultMsg: '<b>邀请码</b>'
    }
  },
  mixins: [inviteCodeJS, mixin],
  components: {
    customerDetail,
    trialDetail
  }
}
</script>



// WEBPACK FOOTER //
// src/page/business/inviteCode.vue